// import { ReactComponent as ReactLogo } from '../assets/icons/logo.svg';

import styles from './Icon.module.scss';

export type ImageType = {
    img: string;
    altText: string;
    width?: number;
}

export interface IIconProps {
    iconIndex: number;
    image: ImageType;
    ariaLabel?: string;
    onClickSharedNumber?: () => void;
    isDisabled?: boolean;
}

export function Icon(props: IIconProps) {
    const { iconIndex, onClickSharedNumber, ariaLabel, image, isDisabled } = props;

    return (
        <button 
            className={styles.icon} 
            onClick={onClickSharedNumber} 
            aria-label={ariaLabel} 
            style={{ /* width: image?.width || 80, height: image?.width || 80, */ opacity: isDisabled ? 0.5 : 1 }}
            data-automationId={iconIndex}
        >
            {
                !!image ?
                <img 
                    alt={image.altText} 
                    src={require(`../assets/${image.img}`)} 
                    className={styles.img} /> :
                iconIndex
            }
        </button>
    );
}